<template>
    <div>
        <div class="content-page" v-if=storedStatusJWT>
            <h2 class="text-center pt2 pb-4">Персональные программы</h2>
            <div class="align-content-center text-center">
                <template>
                    <div id="app1">
                        <ckeditor :editor="editor" v-model="editorData.p1" :config="editorConfig"></ckeditor>
                        <ckeditor :editor="editor" v-model="editorData.p2" :config="editorConfig"></ckeditor>
                    </div>
                    <div>{{ items }}</div>
                    <div v-for="block in blocks">
                        <div
                            class="drop-zone"
                            @drop="onDrop($event, block)"
                            @dragover.prevent
                            @dragenter.prevent
                        >
                            <div
                                class="drag-el"
                                v-for="(item, index) in listBlock(block)"
                                :id="block + '_' + item.id"
                                draggable
                                @dragstart="startDrag($event, item, index)"
                            >
                                {{ item.title }}
                            </div>
                        </div>
                    </div>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
import {mapGetters} from 'vuex';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

export default {
    data: () => ({
        blocks: [1,2],
        items: [
            {
                id: 4,
                title: 'текст A',
                list: 1,
            },
            {
                id: 1,
                title: 'видео B',
                list: 1,
            },
            {
                id: 2,
                title: 'ПП C',
                list: 2,
            },
            {
                id: 3,
                title: 'ПП d',
                list: 2,
            },
        ],
        editor: ClassicEditor,
        editorData: {
            'p1' : '<p>Rich-text editor content000.</p>',
            'p2' : '<p>Rich-text editor content1111.</p>',
        },
        editorConfig: {}
    }),
    computed: {
        listOne() {
            console.log(Array.from(this.items, x => x.list));
            console.log ( this.items.filter(elem=>elem.id))
            console.log( Array.from(new Set(this.items)))
            return this.items.filter((item) => item.list === 1).sort((a, b) => a.id - b.id)
        },
        listTwo() {
            let id = 2
            return this.items.filter((item) => item.list === id).sort((a, b) => a.id - b.id)
        },
        ...mapGetters([
            'storedStatusJWT'
        ])
    },
    created() {
        if (this.storedStatusJWT) {
            this.axios
                .get('/api/region')
                .then(response => {
                    this.region = response.data;
                })
        } else {
            window.location.href = '/home';
        }
    },
    methods: {
        listBlock(position) {
            return this.items.filter((item) => item.list === position).sort((a, b) => a.id - b.id)
        },
        startDrag(evt, item) {
            evt.dataTransfer.dropEffect = 'move'
            evt.dataTransfer.effectAllowed = 'move'
            evt.dataTransfer.setData('itemID', item.id)
        },
        onDrop(evt, list) {
            const itemID = evt.dataTransfer.getData('itemID')
            const item1 = this.items.find((item) => item.id == itemID)
            let itemNewId = item1.id
            let itemIdOld = evt.target.id.substr(2)
            const item2 = this.items.find((item) => item.id == itemIdOld)
            item1.list = list
            item1.id = itemIdOld
            item2.id = itemNewId
            console.log(list)
            console.log(evt.target.id)
        },
    }
}
</script>
<style>

.drop-zone {
    background-color: #eee;
    margin-bottom: 10px;
    padding: 10px;
}

.drag-el {
    background-color: #fff;
    margin-bottom: 10px;
    padding: 5px;
}

.card-deck .card {
    box-shadow: 1px 5px 5px #dae0e5;
}

.btn-paypal {
    box-shadow: 2px 30px 30px #a0b0bd;
    width: 300px;
    height: 100px;
    margin: 20px auto 60px;
}

.card-deck {
    margin-right: 1px;
    margin-left: 1px;
}
</style>
